module.exports = __webpack_public_path__ + "static/media/facebook.848fc413.svg";